module.exports = __webpack_public_path__ + "img/hello.1528f1ef.svg";